import { useEffect, useState } from 'react';
import { DebugAnalyticsTrackerService } from '../service/DebugAnalyticsTrackerService';

type Out = Omit<typeof DebugAnalyticsTrackerService, 'isEnabled'> & {
  isEnabled: boolean;
};

export const useDebugAnalyticsTrackerService = (): Out => {
  const [isEnabled, setIsEnabled] = useState<boolean>(DebugAnalyticsTrackerService.isEnabled());

  useEffect(() => {
    const id = DebugAnalyticsTrackerService.addIsEnabledListener(setIsEnabled);
    return (): void => {
      DebugAnalyticsTrackerService.removeIsEnabledListener(id);
    };
  }, [setIsEnabled]);

  return {
    ...DebugAnalyticsTrackerService,
    isEnabled,
  };
};
